// extracted by mini-css-extract-plugin
export var messageSideLeft = "_na-1";
export var stateContainer = "_na-0";